import React from "react";

export const StatNote = ({ children }) => (
  <div className="innerdetail">
    <span className="line"></span>
    <h6 className="headdetail">{children}</h6>
  </div>
);

export const StatValue = ({ value, unit }) => (
  <h6 className="cardhead">
    {value} {unit && <span className="token">{unit}</span>}
  </h6>
);

const StatCard = ({ icon, label, children, change, notes = [] }) => (
  <div className="innercard">
    <div className="cardtop">
      {icon}
      <div className="topheadings">
        <p className="cardpara">{label}</p>
        {change ? (
          <div className="headrow">
            {children}
            <span className="changepara">{change}</span>
          </div>
        ) : (
          children
        )}
      </div>
    </div>
    {notes.length > 0 && (
      <div className="lowerdetail">
        {notes.map((note, i) => (
          <StatNote key={i}>{note}</StatNote>
        ))}
      </div>
    )}
  </div>
);

export default StatCard;
